import React from  'react';
import { FormattedMessage } from 'react-intl';

class Progress extends React.Component {

    static get defaultProps() {
        return {
            progressText: 'TEXT_PROGRESS_LOADING',
            progress: 100
        }
    }

    render() {
        return (
            <div className="progress">
                <div className="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{width: this.props.progress + '%'}}>
                    <FormattedMessage id={this.props.progressText} /> &hellip;
                </div>
            </div>
        );
    }
}

export default Progress;


// WEBPACK FOOTER //
// ./src/js/components/layout/Progress.react.jsx